// Modules
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';

import { DEFAULT_PAGE_SIZE } from 'constants';
import { mergeQuery } from 'modules/history/actions';
import SVG from 'components/widgets/icons/svg';

// Component
class Pager extends React.Component {
  static propTypes = {
    count: PropTypes.number,
    page: PropTypes.number.isRequired,
    pageSize: PropTypes.number
  };

  static defaultProps = {
    pageSize: DEFAULT_PAGE_SIZE
  };

  constructor() {
    super();

    this.nextPage = this.nextPage.bind(this);
    this.previousPage = this.previousPage.bind(this);
    this.changePage = this.changePage.bind(this);
  }

  nextPage(e) {
    e.preventDefault();
    this.changePage(this.props.page + 1);
  }

  previousPage(e) {
    e.preventDefault();
    this.changePage(this.props.page - 1);
  }

  changePage(page) {
    const { count, pageSize } = this.props;
    const maxPage = Math.ceil(count / pageSize);
    if (page < 1 || page > maxPage) return;

    mergeQuery({ page });
  }

  render() {
    const { count, page, pageSize } = this.props;
    const maxPage = Math.ceil((count || 0) / pageSize);

    return (
      <ul className="pagination">
        <li>
          <button disabled={page === 1} type="button" className="btn btn-secondary" onClick={this.previousPage}>
            <SVG src="svg/chevron-left.svg" /> Prev
          </button>
        </li>
        <li>
          <button disabled={page >= maxPage} type="button" className="btn btn-secondary" onClick={this.nextPage}>
            Next <SVG src="svg/chevron-right.svg" />
          </button>
        </li>
      </ul>
    );
  }
}

function mapStateToProps(state) {
  const query = state.location.query;

  return {
    page: (query.page && Number(query.page)) || 1
  };
}

export default connect(mapStateToProps)(Pager);



// WEBPACK FOOTER //
// ./app/components/widgets/pager/pager.js